export const SERVICE_COLORS = {
  "Excavation": "#8B5E34",
  "Concrete & Foundations": "#64748B",
  "Site Prep & Grading": "#4D7C0F",
  "Decorative & Stamped Concrete": "#0E7490",
  "Retaining Walls": "#57534E",
  "Driveways, Paving & Surfacing": "#1F2937",
  "Drainage": "#2F5F80",
};

export const SERVICE_OPTIONS = Object.keys(SERVICE_COLORS);

export const todayStr = () => new Date().toLocaleDateString("en-CA");

export const isActiveOn = (a, dateStr) =>
  a.start_date <= dateStr && a.end_date >= dateStr;
